import { Fragment } from "react";
import { Autocomplete, InputLabel, TextField, Typography, createFilterOptions } from "@mui/material";
import { Debounce } from "../../../utils";
import { Link } from "react-router-dom";

function SelectField(props) {

  const { label, labelIcon, loading, placeholder, size, disabled, onSearch, addNew, addNewPopup, multiple, selected, onSelect, register, error, labelStyle, options, style } = props

  const filter = createFilterOptions();

  // *For Handle Filter Option
  const handleFilterOptions = (options, params) => {

    const filtered = filter(options, params);

    const { inputValue } = params;
    // *Suggest the creation of a new value
    const isExisting = options.some((option) => inputValue === option.name);
    if (inputValue !== '' && !isExisting && addNew) {
      filtered.push({
        inputValue,
        name: `Add "${inputValue}"`,
      });
    }

    return filtered;
  }

  // *For Handle Option Label
  const handleOptionLabel = (option) => {

    // *Value selected with enter, right from the input
    if (typeof option === 'string') {
      return option;
    }
    // *Add new option created dynamically
    if (option.inputValue && addNew) {
      return option.inputValue;
    }
    // *Regular option
    return option.name;

  }

  // *For Handle Change
  const handleChange = (newValue) => {
    if (typeof newValue === 'string') {
      onSelect(newValue)
      return
    }
    if (newValue && newValue.inputValue && addNew) {
      addNew(newValue?.inputValue)
      return
    }
    return onSelect(newValue)
  }

  // *For Handle Search
  const handleSearch = (value) => {
    if (onSearch) {
      Debounce(() => onSearch(value));
    }
  }

  return (
    <Fragment>
      {label && (
        <InputLabel error={error && true} sx={{ display: 'flex', justifyContent: "space-between", textTransform: "capitalize", fontSize: "14px", fontWeight: "600", color: "#5b6670", ...labelStyle }}>
          {labelIcon && (
            <img src={labelIcon} alt="" width={"13px"} height={"13px"} />
          )}
          {label}
          {addNewPopup && addNewPopup}
        </InputLabel>
      )}
      <Autocomplete
        disabled={disabled}
        size={size ?? "small"}
        loading={loading}
        multiple={multiple}
        isOptionEqualToValue={(option, value) => option?.name === value?.name}
        value={selected}
        options={options}
        filterOptions={(options, params) => handleFilterOptions(options, params)}
        getOptionLabel={(option) => handleOptionLabel(option)}
        onChange={(event, newValue) => handleChange(newValue)}
        onInputChange={(event, newInputValue) => handleSearch(newInputValue)}
        sx={{ mt: 1, ...style }}
        renderOption={(props, option) => {
          const { key, ...otherProps } = props;
          return <li key={option.id} {...otherProps}>{option.name}</li>
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={label ?? placeholder}
            error={error}
            {...register}
          />
        )}
      />
      {error && (
        <Typography variant="caption" color="error" sx={{ textAlign: 'left' }}>{error}</Typography>
      )}
    </Fragment>
  );
}

export default SelectField